import { POLLING_VERSION_PARAM } from "../common/constants";
import PsmBridge from "../common/psm-bridge";
import { EnvNames } from "@turnercode/types"

export const psmDependencies = (psm) => {
  return {
    getVersionPath: () => {
      const urlParams = new Proxy(new URLSearchParams(window?.location?.search), {
        get: (searchParams: URLSearchParams, prop: any) => searchParams.get(prop),
      })
      if (urlParams[POLLING_VERSION_PARAM]) {
        return `webapp/${urlParams[POLLING_VERSION_PARAM]}`
      }
      const environment = psm.getConfig()?.psmEnvironment
      const env = environment === EnvNames.PROD ? 'release' : 'pre'
      const prismVersion = psm.getConfig()?.pollingVersion?.split('/')[2]
      return `webapp/web/${env}/${prismVersion}`;
    },
    getLocalStorage: (key: string) => window.localStorage.getItem(key) ?? '',
    // TODO: get psm_test_ts, or another variable to toggle debugging, without referencing window.psmMgr?
    debugModeEnabled: typeof window.psmMgr?.psm_test_ts !== 'undefined' && window.psmMgr?.psm_test_ts,
    setLocalStorage: (key: string, data: any): void => {
      window.localStorage.setItem(key, JSON.stringify(data))
    },
    // @ts-ignore - Unfortunately effectiveType do not exist on lib DOM types yet
    networkConnectionType: window.navigator.connection?.effectiveType,
    getWMUKID: (setWMUKID: Function): void => {
      setWMUKID(PsmBridge.psm.getWMUKID())
    }
  }
}
